<template>
	<div>
    <v-layout>
      <v-flex md5>
				<h2 class="dark-orange--text font30">{{name}}</h2>
      </v-flex>
      <v-flex md7 class="sc-btns">
				<v-btn color="primary" @click="load_frames">
					<span>Recargar</span>
					<v-icon>refresh</v-icon>
				</v-btn>
				<v-btn color="primary" @click="open_dialog('add_monitoring_detail_component');">
					<span>Agregar componente</span>
					<v-icon>add</v-icon>
				</v-btn>
				<fs1-dialog id="add_monitoring_detail_component" title="Agregar componente">
					<template v-slot:body>
						<div style="text-align:left">
							<in-text v-model="selectedItem.component_title" label="Título del componente"/>
							<in-text v-model="selectedItem.component_profile" label="Perfil Klipfolio"/>
							<in-text v-model="selectedItem.div_id" label="ID componente Klipfolio"/>
							<in-range :max="1000" :min="detail_min" v-model="selectedItem.component_width" label="Ancho del componente %" tag="div" append_str="px"/>
							<in-range :max="1000" :min="detail_min" v-model="selectedItem.component_height" label="Alto del componente %" tag="div" append_str="px"/>
							<in-num v-model="selectedItem.order" label="Orden"/>
						</div>
					</template>
					<template v-slot:footer="{close}">
						<v-btn color="primary" :disabled="disabled_add" @click="()=>selectedItem.id?save():add()">{{selectedItem.id?'Guardar':'Agregar'}} Componente</v-btn>
						<v-btn color="secondary" @click="()=> {close(); selectedItem = {...default_item}}">Cancelar</v-btn>
					</template>
				</fs1-dialog>
      </v-flex>
    </v-layout>
		
		<!-- https://embed.klipfolio.com -->
		<div style="background: lightgrey">
			<div v-for="(d,i) in detail" :key="i" style="vertical-align: top;margin:10px; display:inline-block">
				<iframe
				v-bind="d"
					:id="`external_monitoring_container-${i}`"
					frameborder="0"
					:style="`width: ${d.component_width}px; height:${d.component_height || detail_min}px`"
					sandbox="allow-same-origin allow-scripts"/>
				<div style="text-align: center;">
					<v-btn color="primary" @click="edit(d)"><v-icon>edit</v-icon></v-btn>
					<v-btn color="primary" @click="remove(d)"><v-icon>delete</v-icon></v-btn>
				</div>
			</div>
		</div>

		<fs1-dialog id="remove_monitoring_detail_component" template="warning">
			<template v-slot:body>
				<fs1 tag='h3'>
					Esta acción no se puede deshacer, ¿desea continuar?
				</fs1>
			</template>
			<template v-slot:footer="{close}">
				<v-btn color="primary" @click="()=>{selectedItem.is_deleted=true;save()}">Aceptar</v-btn>
				<v-btn color="secondary" @click="close">Cancelar</v-btn>
			</template>
		</fs1-dialog>
	</div>
</template>
<script>
const default_item = {
	component_title: null,
	component_profile: null,
	div_id: null,
	component_width: null,
	component_height: null,
	order: null,
}

export default {
	data() {
		return {
			default_item,
			detail_min:300,
			detail:[],
			name:'',
			critical_asset:null,
			selectedItem:{...default_item},
		}
	},
	computed:{
		disabled_add() {
			const unfilled = ['component_title','component_profile','div_id','component_width']
				.filter(k => !this.selectedItem[k]);
			return !!unfilled.length
		}
	},
	mounted() {
		/* const head = document.getElementById('external_monitoring_container').contentWindow.document.getElementsByTagName("head")[0];
		const css = document.createElement('style');
		css.innerHTML = `.kf_box{vertical-align: top;margin:10px}`;
		head.appendChild(css); */
		/* const container = document.getElementById('external_monitoring_container').contentWindow.document.getElementsByTagName("body")[0];
			const div1 = document.createElement('div');
			div1.setAttribute('id', 'kf-embed-container-8ec5efeda03a308ba30479f2dfec988e');
			container.appendChild(div1);

			const scr1 = document.createElement('script');
			scr1.setAttribute('src', 'https://embed.klipfolio.com/a/js/embed.api');
			container.appendChild(scr1);
			const scr2 = document.createElement('script');
			//console.log(localStorage.getItem("AS2X"));
			scr2.innerHTML = 'let to10_count = 0; const to10 = () => setTimeout(() => {if (KF) { KF.embed.embedKlip({profile : "8ec5efeda03a308ba30479f2dfec988e",settings : {"width":674,"theme":"light","borderStyle":"round","borderColor":"#cccccc"},title : "Tendencia de Esfuerzos"}); } else if (to10_count < 10){ console.log({to10_count}); to10_count++; to10();} }, 1000);to10();';
			container.appendChild(scr2);

			// const simple_get = document.createElement('script');
			// simple_get.innerHTML = 'var xhr = new XMLHttpRequest(); xhr.open("GET", "http://localhost:3000/tabs/all/", true); xhr.onload = function(){ console.log(xhr.responseText); }; xhr.send();'
			// container.appendChild(simple_get);

			// const simple_post = document.createElement('script');
			// simple_post.innerHTML = "var url = 'http://localhost:3000/tabs/all/'; var data = {username: 'example'}; fetch(url, { method: 'POST', body: JSON.stringify(data),headers:{'Content-Type': 'application/json'}}).then(res => res.json()).catch(error => console.error('Error:', error)).then(response => console.log('Success:', response));";
			// container.appendChild(simple_post);

			const simple_ = document.createElement('script');
			simple_.innerHTML = "if (window.top !== window.self) console.log('D;!!');";
			container.appendChild(simple_);
			 */
	},
	created(){
		const {critical_asset, name} = this.$route.params;
		this.name = name;
		this.critical_asset = critical_asset;
		this.dev_log({critical_asset});

		/* 
		<httpProtocol>
			<customHeaders>
					<add name="X-Frame-Options" value="sameorigin"/>
			</customHeaders>
		</httpProtocol>

		*/

		this.requests.get['online_monitoring_components'](null,{critical_asset})
			.then(r => this.detail = r.map(m=>((m.reload_count = 0) || m)))
			.then(r => this.dev_log({r}) || r)
			.then(r => this.load_frames())
	},
	methods:{
		load_frames() { this.detail.forEach((d,i) => this.load_frame(d,i)) },
		load_frame(d,i) {
				d.reload_count++;
				const body = document.getElementById('external_monitoring_container-'+i).contentWindow.document.getElementsByTagName("body")[0];
				//this.dev_log({d});
				if (d.reload_count === 1) {
					const head = document.getElementById('external_monitoring_container-'+i).contentWindow.document.getElementsByTagName("head")[0];
					const css = document.createElement('style');
					css.innerHTML = `.kf-embed-klip{    width: 100% !important;}`;
					head.appendChild(css);

					const klipfolio = document.createElement('script');
					klipfolio.setAttribute('src', 'https://embed.klipfolio.com/a/js/embed.api');
					body.appendChild(klipfolio);
					
					const div = document.createElement('div');
					div.setAttribute('id', d.div_id);
					div.setAttribute('class', 'kf_box');
					body.appendChild(div);
					if (d.code) {/* code no se inserta pero si no lo trae, significa q el backend no pudo generarlo ya que los datos estaban mal ingresados */
						const scr = document.createElement('script');
						scr.innerHTML += `let to10_count = 0; const to10 = () => setTimeout(() => {if (KF) {KF.embed.embedKlip({profile : "${d.component_profile}",settings : {"width":${d.component_width},"height":${d.component_height},"theme":"${this.dark_t?'dark':'light'}","borderStyle":"round","borderColor":"#cccccc"},title : "${d.component_title}"});} else if (to10_count < 10){ console.log({to10_count}); to10_count++; to10();} }, 1000);to10();`;
						this.dev_log(scr.innerHTML);
						body.appendChild(scr);
					} // if
				} else {
						const div = document.getElementById('external_monitoring_container-'+i).contentWindow.document.getElementById(d.div_id);
						div.innerHTML = '';
						const scr = document.createElement('script');
						scr.innerHTML += `KF.embed.embedKlip({profile : "${d.component_profile}",settings : {"width":${d.component_width},"height":${d.component_height},"theme":"${this.dark_t?'dark':'light'}","borderStyle":"round","borderColor":"#cccccc"},title : "${d.component_title}"});`;
						this.dev_log(scr.innerHTML);
						body.appendChild(scr);
				}
		},
		add(){
			this.close_dialog('add_monitoring_detail_component');
			const {critical_asset} = this;
			this.requests.post['online_monitoring_component/a/all'](Object.assign({critical_asset},this.selectedItem))
				.then(r => {
					if (r.div_id) {
						r.reload_count = 0;
						r.code = '<div></div>';
						this.detail.push(r);
  					this.$nextTick(() => {
							this.load_frame(r, this.detail.indexOf(r))
						})
						
						this.selectedItem = {...default_item};
					}
				})
		},
		edit(d) {
			this.selectedItem = {...d};
			this.open_dialog('add_monitoring_detail_component');
		},
		save() {
			this.close_dialog();
			this.requests.patch['online_monitoring_component/a'](this.selectedItem)
				.then(r => {
					if (r && r.id) {
						const item = this.detail.find(d => d.id === r.id);
						Object.assign(item,r);
						item.is_deleted ===  true
							?	this.detail.splice(this.detail.indexOf(item),1)
							: this.load_frame(item, this.detail.indexOf(item));
						this.selectedItem = {...default_item};
					}	
				})
		},
		remove(d) {
			this.selectedItem = d;
			this.open_dialog('remove_monitoring_detail_component');
		}
	},
};
</script>
